<template lang="html">
  <v-container fluid class="height-100">
    <v-row class="height-100">
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="align-self-end">
        <div v-if="isCode">
          <div class="px-12">
            <div class="card-unique-code-title">
              {{ $t('enter_the_code') }}
            </div>
            <div class="card-unique-code-subtitle">
              {{ $t('get_the_code_at_the_cashier') }}
            </div>
            <div class="my-6">
              <div class="">
                <InputCode v-model="form.code" :error-message="error_unique_code" />
              </div>
            </div>
          </div>
          <v-btn v-if="!loadingCode" type="submit" large color="primary" x-large block class="text-none mb-3" @click="validateCode()">
            {{ $t('next') }}
          </v-btn>
          <div v-else class="d-flex align-center justify-center mb-3">
            <v-progress-circular indeterminate color="primary" />
          </div>
          <!-- <v-btn type="submit" color="primary" outlined x-large block class="text-none" @click="selectManualTable">
            Pilih meja sendiri
          </v-btn> -->
        </div>
      </v-col>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="align-self-end">
        <v-btn text color="primary" x-large block class="text-none font-weight-bold" @click="goBack()">
          {{ $t('back_to_homepage') }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  dineinchecking as dineinCheck
} from '@/api/setting'
import InputCode from '@/components/modules/InputCode'
export default {
  components: {
    InputCode
  },
  data() {
    return {
      isCode: false,
      error_unique_code: '',
      loadingCode: false,
      form: {
        code: ''
      },
      geoLocation: {
        location_lat: 0,
        location_lon: 0
      },
      paused: false,
      origins: [],
      destinations: []
    }
  },
  created() {
    this.checkStore()
  },
  beforeDestroy() {
    this.$store.state.qrmode = false
  },
  methods: {
    selectManualTable() {
      this.$router.push({ name: 'listoutlets' }).catch(() => {})
    },
    goBack() {
      const astra_outlet = this.$store.state.store_astra
      const tmii_outlet = this.$store.state.store_tmii
      const url_id = this.$store.state.url_domain

      if (tmii_outlet.indexOf(url_id) !== -1) {
        window.location.href = 'https://order.kulinertmii.id'
      } else if (astra_outlet.indexOf(url_id) !== -1) {
        window.location.href = 'https://zestloungemenaraastra.myolsera.com'
      } else {
        this.$router.push({ name: 'home' }).catch(() => {})
      }
    },
    async checkStore() {
      var selected_store = null
      selected_store = await this.$store.state.selected_outlet
      if (selected_store) {
        this.paused = true
        if (selected_store.store_is_open === 0) {
          this.$router.push({ name: 'store_is_close' }).catch(() => {})
        } else {
          if (selected_store.setting.use_dinein === 1) {
            if (selected_store.setting.use_unique_code_checking_dinein === 0) {
              // request pak ali remove gps tanggal 24 oktober 2022
              this.$router.push({ name: 'total_guest_dinein' }).catch(() => {})

              // this.origins.push({
              //   lat: Number(selected_store.location_lat),
              //   lng: Number(selected_store.location_lon)
              // })
              // if (navigator.geolocation) {
              //   navigator.geolocation.getCurrentPosition(this.successPosition, this.failurePosition, {
              //     enableHighAccuracy: true,
              //     timeout: 5000
              //   })
              // } else {
              //   alert(`Browser doesn't support Geolocation`)
              // }
            } else {
              this.isCode = true
            }
          } else {
            this.$router.push({ name: 'non_active' }).catch(() => {})
          }
        }
      } else {
        this.paused = false
      }
    },
    successPosition: async function(position) {
      this.destinations.push({
        lat: Number(position.coords.latitude),
        lng: Number(position.coords.longitude)
      })
      const radiusDinein = await this.$curDistance(this.origins[0].lat, this.origins[0].lng, this.destinations[0].lat, this.destinations[0].lng)
      if (radiusDinein > 250) {
        this.$store.state.block_tooLong = true
      } else {
        this.$router.push({ name: 'total_guest_dinein' }).catch(() => {})
      }
    },
    failurePosition: function() {
      if (this.$store.state.selected_type === 'DELIVERY') {
        this.$store.state.must_allow_location = true
      }
      this.$store.state.block_location = true
    },
    async validateCode() {
      this.error_unique_code = ''
      this.loadingCode = true
      try {
        await dineinCheck(this.form)
        this.$store.state.loading_axios = false
        this.$router.push({ name: 'total_guest_dinein' }).catch(() => {})
      } catch (e) {
        this.error_unique_code = e.string
      }
      this.loadingCode = false
      this.form.code = ''
    }
  }
}
</script>
